import { Trans, useTranslation } from 'react-i18next';
import { InfoHint } from '@/shared/components';
import { TRANSACTIONS_SLA_LINKS } from '@/shared/config';
import { useAppSettingsStore } from '@/shared/lib';
import ClockIcon from '@/shared/assets/clock-icon.svg?react';

export const OperationProcessingTimeHint = () => {
  const { t } = useTranslation();
  const { getLanguage } = useAppSettingsStore();

  const knowledgeBaseLink =
    getLanguage() === 'ru'
      ? TRANSACTIONS_SLA_LINKS.ru
      : TRANSACTIONS_SLA_LINKS.en;

  return (
    <InfoHint
      title={t('historyPage.processingTime.title')}
      icon={<ClockIcon />}>
      <Trans
        i18nKey="historyPage.processingTime.description"
        components={{
          kb: (
            <a
              href={knowledgeBaseLink}
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary-cyan underline"
            />
          ),
        }}
      />
    </InfoHint>
  );
};
